import { render, staticRenderFns } from "./FatturatoTrimestre.vue?vue&type=template&id=45f05ef8&scoped=true&"
import script from "./FatturatoTrimestre.vue?vue&type=script&lang=js&"
export * from "./FatturatoTrimestre.vue?vue&type=script&lang=js&"
import style0 from "./FatturatoTrimestre.vue?vue&type=style&index=0&id=45f05ef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f05ef8",
  null
  
)

export default component.exports